import { Flag, Globe2, MapPin } from "lucide-react";
import { EvidenceChip } from "@/components/iv/scorecard/Bits";

const META = {
  local: { icon: MapPin, title: "Local Lens", sub: "Pin-Code Catchment" },
  country: { icon: Flag, title: "Country Lens", sub: "National Market" },
  global: { icon: Globe2, title: "Global Lens", sub: "International Benchmark" },
};

const Box = ({ label, children, testId }) => (
  <div className="rounded-lg border border-white/[0.06] bg-white/[0.02] p-3" data-testid={testId}>
    <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-1 text-xs leading-relaxed text-slate-200">{children}</p>
  </div>
);

export const GeoLensCards = ({ geographies }) => (
  <section aria-labelledby="geo-title" data-testid="geo-lenses">
    <h2 id="geo-title" className="mb-3 text-lg font-bold text-white">3 Geographical Lenses</h2>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {geographies.map((g) => {
        const m = META[g.level];
        const na = g.is_applicable === false || g.lens_score == null;
        return (
          <article key={g.level} className="iv-glass flex h-full min-w-0 flex-col gap-3 rounded-2xl p-4" data-testid={`geo-lens-${g.level}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="flex min-w-0 items-center gap-2">
                <m.icon className="h-4 w-4 shrink-0 text-cyan-300" aria-hidden="true" />
                <div className="min-w-0">
                  <p className="text-sm font-bold text-white">{m.title}</p>
                  <p className="truncate text-[11px] text-slate-400">{m.sub} · {g.region_label}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-mono text-lg font-bold text-white" data-testid={`geo-lens-${g.level}-score`}>{na ? "N/A" : `${Math.round(g.lens_score * 10)}/100`}</p>
                <p className="text-[10px] text-slate-500" data-testid={`geo-lens-${g.level}-confidence`}>{g.confidence_pct ?? "—"}% confidence</p>
              </div>
            </div>
            <Box label="Key Geographic Finding" testId={`geo-lens-${g.level}-finding`}>{g.key_finding || g.market_summary}</Box>
            <Box label="Economic Benchmark" testId={`geo-lens-${g.level}-benchmark`}>{g.economic_benchmark || g.demand_signal}</Box>
            <div className="mt-auto">
              <EvidenceChip type={g.source_url || (g.source_citation && !/estimate/i.test(g.source_citation)) ? "sourced_fact" : "method_estimate"}
                citation={g.source_citation} date={g.source_date} url={g.source_url} />
            </div>
          </article>
        );
      })}
    </div>
  </section>
);
